import { render, staticRenderFns } from "./askBot.vue?vue&type=template&id=8e82e862"
import script from "./askBot.vue?vue&type=script&lang=js"
export * from "./askBot.vue?vue&type=script&lang=js"
import style0 from "./askBot.vue?vue&type=style&index=0&id=8e82e862&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports